import React, { FunctionComponent, useEffect, useState } from "react";
import { MenuItem as MUIMenuItem, Typography } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ArrowLeft from "@mui/icons-material/ArrowLeft";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import UserMenuLabel from "components/molecules/menu/SideMenu/SideMenuItem/UserMenuLabel";
import { FormattedMessage } from "react-intl";
import { User } from "interfaces/user/user";
import WatchedLink from "components/atoms/link/WatchedLink";
import styles from "components/molecules/menu/SideMenu/SideMenuItem/sideMenuItem.module.scss";
import { MenuItem } from "interfaces/menu/menu";

interface SideMenuItemContainerProps {
    icon: JSX.Element;
    item: MenuItem;
    mobileMenuOpen: boolean;
    onCloseMobileMenu: () => void;
    reduce: boolean;
    selectedItem: MenuItem;
    selectedSubItem: MenuItem;
    onSelectMenuItem: (item: MenuItem) => void;
    subMenuOpen: boolean;
    isLanguageItemSelected?: boolean;
    userMenuLabel?: boolean;
    user?: User;
}

export const SideMenuItem: FunctionComponent<SideMenuItemContainerProps> = ({
    icon,
    item,
    reduce,
    selectedItem,
    onSelectMenuItem,
    isLanguageItemSelected,
    selectedSubItem,
    userMenuLabel,
    user,
    mobileMenuOpen,
    onCloseMobileMenu,
    subMenuOpen,
}) => {
    const [languageItemSelected, setLanguageItemSelected] = useState(false);
    const isSelected = selectedItem && selectedItem.label === item.label || languageItemSelected;
    const isSelectedSubitem = selectedSubItem && selectedSubItem.label === item.label;
    const isParent = item?.subItems ? true : false;

    const handleOnClick = () => {
        onSelectMenuItem(item);
        setLanguageItemSelected(item.label === "menu_language");
    };

    return (
        <>
            <div className={styles.wrapper}>
                <WatchedLink
                    noUnderline
                    to={item.href}
                    key={item.label}
                    mobileMenuOpen={mobileMenuOpen}
                    onCloseMobileMenu={onCloseMobileMenu}
                    isLanguageItemSelected={isLanguageItemSelected}
                    isParent={isParent}
                >
                    <MUIMenuItem
                        selected={isSelected}
                        onClick={handleOnClick}
                        className={`${styles["menu-item"]} ${reduce ? `${styles.reduced}` : ""} ${isSelected ? styles.selected : ""} ${item.isSubItem ? `${styles["sub-item"]}` : ""} ${isSelectedSubitem ? `${styles["sub-item-selected"]}` : ""}`}>
                        <ListItemIcon>
                            {icon}
                        </ListItemIcon>
                        {!reduce &&
                            <>
                                {/* menu items labels for user pages (previously a sub-menu) */}
                                {userMenuLabel && <UserMenuLabel user={user} />}

                                {/* menu items labels for pages */}
                                {!userMenuLabel &&
                                    <Typography>
                                        <FormattedMessage id={item.label} />
                                    </Typography>
                                }
                            </>
                        }
                        {(isSelected || isSelectedSubitem) && !item?.subItems && !languageItemSelected &&
                            <div className={styles["sidebar-item-arrow"]}>
                                <ArrowLeft />
                            </div>
                        }
                        {/* parent item icon */}
                        {isParent &&
                            <div className={`${styles["sidebar-item-arrow-dropdown"]} ${subMenuOpen ? styles.open : ""}`}>
                                <ArrowDropDownIcon />
                            </div>
                        }
                        {languageItemSelected && !isLanguageItemSelected && <KeyboardArrowUpIcon sx={{ position: "absolute", right: 0 }} />
                        }
                    </MUIMenuItem>
                </WatchedLink>
            </div>

        </>
    )
}
